/** 讨论列表项 (V2 字段) */
export interface IDiscussionItem {
  id: number;
  cluster_id: string;
  /** 本条 Event 批次开始时间（下钻必传） */
  start_time: string;
  /** 本条 Event 批次结束时间（下钻必传） */
  end_time: string;
  avg_sentiment: number;
  event_title_en: string;
  event_title_cn: string;
  event_title: string;
  event_gpt_content_en: string;
  event_gpt_content_cn: string;
  event_gpt_content: string;
  /** Event 原始 mentions */
  mentions: number;
  /** 关联 feeds 去重条数（主贴+评论） */
  total_comments: number;
  /** 主贴条数 */
  post_count: number;
  /** 评论条数 */
  comment_count: number;
  /** 去重发言人数 */
  unique_reviewers: number;
  /** 总互动数 */
  total_engagement: number;
  /** 总点赞数 */
  total_likes: number;
  /** 重要度分数 */
  important_score: number;
  new_icon: number;
  hot_icon: number;
  rise_icon: number;
  important_rank: number;
  /** 数据情感 */
  data_sentiment: string;
  /** 关键词列表 */
  keywords: any[];
  channel_type: string;
  days: number;
  event_stage?: 'New' | 'Rising';
}

/** 排序字段 (V2 排序映射) */
export type TSortBy =
  | 'total_comments'
  | 'engagement'
  | 'likes'
  | 'unique_reviewers';

/** V2 排序选项 */
export const SORT_OPTIONS: { value: TSortBy; text: string }[] = [
  { value: 'total_comments', text: 'Mentions' },
  { value: 'unique_reviewers', text: 'Reviewers' },
  { value: 'engagement', text: 'Engagement' },
  { value: 'likes', text: 'Likes' },
];

export const activeKeysMap = {
  total_comments: 'total_comments',
  engagement: 'total_engagement',
  likes: 'total_likes',
  unique_reviewers: 'unique_reviewers',
};

/** 指标配置 */
export const METRIC_CONFIG: {
  key: keyof IDiscussionItem;
  labelKey: string;
  label?: string;
}[] = [
  { key: 'total_comments', labelKey: 'Comments', label: 'Mentions' },
  { key: 'unique_reviewers', labelKey: 'Reviewers' },
  { key: 'total_engagement', labelKey: 'Engagement' },
  { key: 'total_likes', labelKey: 'Likes' },
];

// ─── 趋势图相关类型 ───

/** 趋势图数据点 */
export interface ITrendPoint {
  /** 日期，格式: YYYY-MM-DD */
  date: string;
  /** 当日提及量 */
  mentions: number;
}

/** 趋势图批量接口单项 */
export interface ITrendBatchItem {
  /** 事件 cluster_id */
  cluster_id: string;
  /** 趋势数据，按日期升序排列 */
  trend: ITrendPoint[];
}

/** 趋势图批量接口响应 */
export interface ITrendBatchResponse {
  /** 趋势时间范围开始，YYYY-MM-DD HH:mm:ss */
  timeline_of_start_time: string;
  /** 趋势时间范围结束，YYYY-MM-DD HH:mm:ss */
  timeline_of_end_time: string;
  list: ITrendBatchItem[];
}

/** 趋势图 key→数据映射 */
export type TTrendMap = Record<string, ITrendPoint[]>;
